import { post } from ".";

export function CreateWebRtcSample(options = {}) {
    return post<any>("/app/api/web_rtc_samples", options);
}
